<template>
  <div class="item-detail">
    <vue-headful v-if="item"
      :title="item.name?'영양제웨건 - '+item.name:'영양제웨건'"
    />
    <h1 v-if="item" id="title">
      {{item.name}}
      <b-badge 
        class="badge-rank" 
        pill variant="danger" 
        v-for="rank in ranks" :key="rank.id"
        :to="`/nutri/${rank.id}`"
      >
        {{rank.name}} 함량 {{rank.value}}위
      </b-badge>
      <a v-b-modal.modal-item-report class="float-right button-icon"><b-icon-exclamation-triangle /></a>
      <b-modal 
        id="modal-item-report"
        title="오류 신고"
        @ok="report"
      >
        <report-modal :_id="item._id" :name="item.name" ref='report'/>
      </b-modal>
    </h1>
    <b-row v-if="item">
      <b-col sm="4">
        <div class='div-wrapper img-wrapper'>
          <img v-if="item.hasImage" :src="`${env.SERVER_URI}/api/item/${item._id}/image`" />
          <b-icon-images v-if="!item.hasImage" />
        </div>
      </b-col>
      <b-col sm="4" class="div-wrapper nutri-chart-wrapper">
        <h5>제품 정보</h5>
        <table id="info-table">
          <tr v-if="brand">
            <td>브랜드</td>
            <td>{{brand.name}}</td>
          </tr>
          <tr>
            <td>수량</td>
            <td>{{item.amount}} {{item.unit}}</td>
          </tr>
          <tr>
            <td>일일권장량</td>
            <td>{{item.daily_amount}} {{item.unit}}</td>
          </tr>
          <tr>
            <td>영양소 ({{item.daily_amount}}{{item.unit}} 당)</td>
            <td>
              <div class="nutri-info">
                <b-badge 
                  class="badge-nutri"
                  variant='warning'
                  v-for="nutri in nutritions"
                  :key=nutri._id
                  :to="`/nutri/${nutri._id}`"
                >
                  {{nutri.name}}: {{nutri.value}} {{nutri.unit}}
                </b-badge>
              </div>
            </td>
          </tr>
          <tr v-if="!!item.remarks">
            <td>특징</td>
            <td>
              <span v-for="(remark, key) in item.remarks" :key=key>
                {{remark}}
              </span>
            </td>
          </tr>
        </table>
      </b-col>
      <b-col sm="4" class="div-wrapper nutri-chart-wrapper">
        <h5>영양성분 함량표 (1{{item.unit}} 당) 
          <a v-b-modal.modal-nutri-chart class="button-icon"><b-icon-question-circle /></a>
        </h5>
        <b-modal 
          id="modal-nutri-chart"
          hide-header
          hide-footer
          centered
        >
          <p>식약처에서 고시한 1일 영양성분 기준치 대비 제품에 함량된 영양소의 양을 그래프로 나타낸 것입니다.</p>
          <p>(1일 영양성분 기준치가 없는 성분에 대해서는 식약처가 권장하는 1일섭취량의 평균으로 대신해서 계산했습니다.)</p>
          <!-- <p>* 영양 성분 함량이 식약처 고시 최소 권장량 미만일 경우 빨간색으로 표시됩니다.</p>
          <img width="90%" src="/static/nutrichart.png" /> -->
        </b-modal>
        <b-form-group>
          <!-- <b-form-radio-group
            v-model="graph_criteria"
          >
            <b-form-radio 
              v-for="criteria in [{value: 0, text: '최소'}, {value: 1, text: '최대'}]"
              :key="criteria.value"
              :value="criteria.value"
            >
              {{criteria.text}}
            </b-form-radio>
          </b-form-radio-group> -->
        </b-form-group>
        <b-row>
          <nutri-chart 
            :nutritions="nutritions" 
            :styles="{
              height: String(Math.min(Math.max(nutritions.length * 30, 150), 400)) + 'px', 
              width: '100%',
              position: 'relative'
            }"
          />
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="item">
      <b-col sm="8" class="div-wrapper table-wrapper">
        <h5>영양성분별 100원당 함유량</h5>
        <b-row>
          <b-col sm="10">
            <b-form-group label="영양성분">
              <b-form-radio-group
                v-model="nutri_id"
              >
                <b-form-radio 
                v-for="nutri in nutritions"
                :key="nutri._id"
                :value="nutri._id">
                  {{nutri.name}}<span v-if="nutri.subname">({{nutri.subname}})</span>
                  <b-badge variant="danger" v-if="nutri.core">핵심성분</b-badge>
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="calc-wrapper">
          <b-button variant="info" v-b-toggle.calc-collapse size="sm">계산기</b-button>
          <b-collapse id="calc-collapse">
            <b-card class="nutri-calc">
              <p>가격이 <input type='number' v-model="calc_price" placeholder="가격" /> 원이고</p>
              <p>갯수가 <input type='number' v-model="calc_amount" placeholder="갯수" /> 개일 때,</p>
              <p class="calc-result">
                100원당 <b>{{nutri_name}}</b> 함유량은 
                <b>
                  {{numberWithCommas((item.amount * nutri_amount / (calc_price / calc_amount)*100).toFixed(2))}}
                  {{nutri_unit}}
                </b>
                입니다.
              </p>
            </b-card>
          </b-collapse>
        </div>
        <div
          >총 {{prices.length}}개의 가격 
          <span class="memo">* 가격은 접속 환경마다 다를 수 있습니다</span>
        </div>
        <b-table 
          bordered
          dark
          sticky-header
          selectable
          @row-selected="onRowSelected"
          class="price-table"
          ref='priceTable'
          :items="prices"
          :fields="isMobile?[fields[0]].concat(fields.slice(3)):fields"
          :sort-by="sortBy"
          >
            <template v-slot:cell(price)="data">
              <div class="text-right">{{numberWithCommas(data.value.toFixed(0))}}원</div>
            </template>
            <template v-slot:cell(ship)="data">
              <div class="text-right">{{numberWithCommas(data.value.toFixed(0))}}원</div>
            </template>
            <template v-slot:cell(unit_price)="data">
              <div class="text-right">{{numberWithCommas(data.value.toFixed(0))}}원</div>
            </template>
            <template v-slot:cell(unit_total)="data">
              <div class="text-right">{{numberWithCommas(data.value.toFixed(0))}}원</div>
            </template>
            <template v-slot:cell(unit_amount)="data">
              <div class="text-right">{{(item.amount * nutri_amount/data.item.unit_total*100).toFixed(2)}} {{nutri_unit}}</div>
            </template>
            <template v-slot:cell(link)="data">
              <a v-if="data.item.mall._id != 'offline'" :href="data.item.link" target="_blank">{{data.item.mall.name}}</a>
              <a v-if="data.item.mall._id == 'offline'" v-b-modal.modal-offline-guide>약국</a>
              <b-modal 
                id="modal-offline-guide"
                hide-header
                hide-footer
                centered
              >
                <p>약국에서 판매하는 상품입니다. 자세한 가격은 약국에 문의해주세요.</p>
              </b-modal>
            </template>
        </b-table>
        <div>
          <b-button variant="danger" size="sm" v-if="selected.length > 0" @click="reportBad">
            잘못된 가격 신고
            <b-spinner v-if="reportLoading" variant="primary"></b-spinner>
          </b-button>
          <div class="float-right">업데이트 날짜: {{updated}}</div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {api_get, isMobile, env} from '../util'
import VueHeadful from 'vue-headful'
import {
    BRow, BCol, BTable, BBadge, BFormGroup, BFormRadioGroup, BFormRadio, 
    BFormCheckboxGroup, BSpinner, BCollapse, BIconImages, BIconQuestionCircle, BIconExclamationTriangle
} from 'bootstrap-vue'
import NutriChart from './common/NutriChart'
import ReportModal from './common/ReportModal'

export default {
  name: 'ItemDetailComponent',
  components: {
    BRow, BCol, BTable, BBadge, BFormGroup, BFormRadioGroup, BFormRadio, 
    BFormCheckboxGroup, BSpinner, BCollapse, BIconImages, BIconQuestionCircle, BIconExclamationTriangle,
    VueHeadful, NutriChart, ReportModal
  },
  props: {
    id: String
  },
  data () {
    return {
      fields: [
        {key: 'amount', label: 'N', sortable: true},
        {key: 'price', label: '가격', sortable: true},
        {key: 'ship', label: '배송비', sortable: true},
        {key: 'unit_price', label: '1개당', sortable: true},
        {key: 'unit_total', label: '배송비포함', sortable: true},
        {key: 'unit_amount', label: '100원당 함유량'},
        {key: 'link', label: '쇼핑몰'},
      ],
      item: null,
      nutri_id: null,
      prices: [],
      nutritions: [],
      brand: null,
      selected: [],
      calc_amount: 1,
      calc_price: 1000,
      sortBy: 'unit_total',
      graph_criteria: 0,
      isMobile: isMobile(),
      reportLoading: false,
      env: env,
    }
  },
  mounted() {
    this.get_item()
    this.get_prices()
    this.get_nutritions()
  },
  computed: {
    updated: function() {
      var time = new Date(this.item.price_updated)
      return time.toLocaleDateString()
    },
    nutri_name: function() {
      if (this.nutritions.length > 0 && this.nutri_id) {
        return this.get_nutri_item(this.nutri_id).name
      }
    },
    nutri_unit: function() {
      if (this.nutritions.length > 0 && this.nutri_id) {
        return this.get_nutri_item(this.nutri_id).unit
      }
    },
    nutri_amount: function() {
      if (this.nutritions.length > 0 && this.nutri_id) {
        return this.get_nutri_item(this.nutri_id).value
      }
    },
    ranks: function() {
      if (this.item && this.nutritions.length > 0) {
        if (this.item.rank)
          return Object.entries(this.item.rank).map((rank) => ({
            id: rank[0],
            name: this.get_nutri_item(rank[0]).name,
            value: rank[1]
          })).sort((a, b) => a.value-b.value)
        else
          return []
      }
    }
  },
  methods: {
    get_item() {
      api_get(`item/${this.id}`).then(res => {
        this.item = res.data
        if (this.item.brand)
          this.get_brand()
      }).catch(err => {
        console.log(err)
        this.$router.push('/404')
      })
    },
    get_brand() {
      api_get(`brand/${this.item.brand}`).then(res => {
        this.brand = res.data
      })
    },
    get_prices() {
      api_get(`item/${this.id}/prices`).then(res => {
        this.prices = res.data
      })
    },
    get_nutritions() {
      api_get(`item/${this.id}/nutritions`).then(res => {
        this.nutritions = res.data
        this.nutri_id = this.nutritions[0]._id
      })
    },
    get_nutri_item(nutri_id) {
      return this.nutritions.filter(n => n._id == nutri_id)[0]
    },
    report() {
      this.$refs.report.submit().then( res => {
        alert('오류 신고가 완료되었습니다.')
      })
    },
    onRowSelected(items) {
      this.selected = items
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.main {
  padding: 20px;
}
.bold {
  font-weight: bold;;
}
.item-detail {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  font-size: 0.8rem;
  padding: 30px;
  min-height: calc(100vh - 51px);
}
h1#title {
  font-size: 1.5rem;
  margin-bottom: 30px;
}
.div-wrapper {
  margin-top: 20px;
}
.table-wrapper {
  overflow: auto;
}
.img-wrapper {
  text-align: center;
  margin-bottom: 20px;
}
.img-wrapper > img, svg {
  width: 60%;
  height: 60%;
  display: inline-block;
}
.price-table {
  max-height: 52vh;
}
.nutri-calc >>> input {
  width: 60px;
}
.badge-nutri {
  margin: 2px;
  color: #000;
}
.badge-rank {
  margin: 2px;
  font-size: 0.8rem;
  color: #fff;
}
.memo {
  font-size: 0.7rem;
  color: grey;
}
#info-table {
  width: 100%;
}
#info-table >>> td {
  line-height: 2;
  vertical-align: top;
}
#info-table >>> td:first-child {
  width: 40%;
}
.nutri-info {
  max-height: 200px;
  overflow: auto;
}
.button-icon > svg {
  width: 20px;
}
.calc-wrapper {
  margin-bottom: 20px;
}
.calc-result {
  font-size: 0.9rem;
}
@media only screen and (max-width: 600px) {
  .price-table {
    max-height: 25vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ItemDetail.vue